import i18n from '@/locales/i18n';
import { request } from '@koi-design/vix-tools';
import { packApi } from '@/libs/tools';
import store from '@/store';
import gConf from 'gConf';

const { augeUrl, augeGateway } = gConf;

export function registerApi(data, mode = 'email') {
  let url = '/api/api-user/register/';
  if (mode === 'phone') {
    url += '?v=1';
  }
  return request({
    url,
    method: 'post',
    data,
    catchAll: true
  });
}
export function getEmialCodeAPi(data) {
  return request({
    url: '/api/api-user/send_mail_vcode/',
    method: 'post',
    data,
    catchAll: true
  });
}
export function getPhoneCodeAPi(data) {
  return request({
    url: '/api/api-user/send_sms_vcode/',
    method: 'post',
    data,
    catchAll: true
  });
}
export function loginApi(data, mode = 'username') {
  let url =
    mode === 'username'
      ? `/api/api-user/login/?v=1&secret=${data.secret}`
      : `/api/api-user/sms_login/?secret=${data.secret}`;
  let formData = null;
  if (data.code) {
    url = `${augeUrl}${augeGateway}/auth/loginByCode`;
    formData = new FormData();
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
  }
  return new Promise((resolve, reject) => {
    request({
      url,
      method: 'post',
      data: data.code ? formData : data
    })
      .then(res => {
        resolve({
          userId: res.user.id,
          token: res.access,
          sessionId: res.sessionid,
          companyId: res?.companyId,
          companyName: res?.companyName,
          userName: res.user.username,
          nickname: res.user.nickname,
          homeLandId: res.homeland?.id,
          email: res.user.email,
          mobile: res.user.mobile,
          avatar: res.user.avatar,
          expire_time: res.user.expire_time,
          need_bind_mobile: res.user.need_bind_mobile,
          refresh_token: res.refresh,
          expires_in: res.expires_in,
          api_key: res.user?.api_key,
          is_main_account: res.user?.is_main_account
        });
        store.commit('setIsCompanyUser', !!res?.companyId);
        store.commit('updateHomelandId', {
          homeland: res.homeland?.id,
          user: res.user.id,
          homeland_name: res.homeland?.name,
          homeland_type: res.homeland?.homeland_type,
          homeland_owner: res.user.nickname,
          homeland_owner_id: res.homeland?.id,
          role: res?.companyId ? 'admin' : 'home_owner',
          response_role: i18n.global.t(
            'api.permission.2fa093b3b799a1735dbe1caa79e6fd59'
          )
        });
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function refreshAzureTokenApi(accessToken, refreshToken) {
  return request({
    url: '/api/api-user/token/refresh_azure/',
    method: 'post',
    data: {
      access_token: accessToken,
      refresh_token: refreshToken
    }
  });
}
export function logoutApi(data) {
  return request({
    url: '/api/api-user/logout/',
    method: 'post',
    data
  });
}
export const editUserInfoApi = (data, id) => {
  return packApi({
    url: `/api/api-user/user/users/${id}/`,
    method: 'put',
    data
  });
};
export const findPasswordBackApi = data => {
  return request({
    url: `/api/api-user/recover_password/?v=1`,
    method: 'post',
    data,
    catchAll: true
  });
};
export const modidyPassword = data => {
  return packApi({
    url: `/api/api-user/user/users/update_password/`,
    method: 'post',
    data
  });
};
export const getCaptchaApi = data => {
  return request({
    url: `/api/api-user/captcha/`,
    method: 'post',
    data
  });
};
export const bindPhoneApi = data => {
  return request({
    url: `/api/api-user/bind_mobile/`,
    method: 'post',
    data
  });
};
export const bindEmailApi = data => {
  return request({
    url: `/api/api-user/bind_mail/`,
    method: 'post',
    data
  });
};
export const cancelAccountApi = () => {
  return packApi({
    url: `/api/api-user/user_account_cancellation/`,
    method: 'get'
  });
};
export const checkTokenApi = () => {
  return request({
    url: `/api/api-user/user/users/get_user_token_status/`,
    method: 'get'
  });
};
